import {createOverlay} from "@chakra-ui/react";
import DialogOverlay from "./components/DialogOverlay";
import {MdBusiness, MdHome} from "react-icons/md";
import {IoIosCheckmarkCircleOutline} from "react-icons/io";
import {RxCrossCircled} from "react-icons/rx";

export const INFO_EMAIL = "info@roots-solar.com";

export const dialog = createOverlay((props) => <DialogOverlay {...props}/>);

export const quizSteps = [
    {
        question: "Do you need solar panels for your home or business?",
        type: "choice",
        options: [
            {label: "Home", value: "home", icon: MdHome},
            {label: "Business", value: "business", icon: MdBusiness},
        ],
        triggerConversion: () => window.obApi?.('track', 'honeypot_quiz_step1')
    },
    {
        question: "Do you own the property?",
        type: "choice",
        options: [
            {label: "Yes", value: "yes", icon: IoIosCheckmarkCircleOutline},
            {label: "No", value: "no", icon: RxCrossCircled},
        ],
        triggerConversion: () => {
          window.obApi?.('track', 'honeypot_quiz_step2');
          window.zemApi?.('track', 'second_step');
        }
    },
    {

        question: "What is your primary motivation for switching to solar energy?",
        type: "choice",
        options: [
            {label: "Lower energy bills", value: "lower_bills"},
            {label: "Reduce your carbon footprint", value: "carbon_footprint"},
            {label: "Increase property value", value: "property_value"},
            {label: "Government incentives", value: "incentives"},
        ],
        triggerConversion: () => window.obApi?.('track', 'honeypot_quiz_step3')
    },
    {
        question: "What is the average monthly electricity bill?",
        type: "choice",
        options: [
            {label: "Below 60€", value: "below_60"},
            {label: "60€ - 120€", value: "60_to_120"},
            {label: "120€ - 200€", value: "120_to_200"},
            {label: "Above 200€", value: "above_200"},
            {label: "I don't know", value: "unknown"},
        ],
        triggerConversion: () => window.obApi?.('track', 'honeypot_quiz_step4')
    },
    {
        question: "Your email address",
        type: "email",
        placeholder: "e.g. example@gmail.com",
        triggerConversion: () => window.obApi?.('track', 'honeypot_quiz_email')
    },
    {
        type: "email_verification",
        question: "Please enter the verification code sent to your email",
        triggerConversion: () => window.obApi?.('track', 'honeypot_quiz_verification'),
    },
    {
        type: "message",
        question: "✅ Your email has been successfully verified!",
        description: "Thanks for confirming. We'll be in touch with your personalized solar quote shortly.",
    }
];

export const houseConfigs = [
  {
    value: "smallHouse",
    label: "1-2 bedrooms",
    numBedrooms: "1-2",
    numPanels: "6",
    minAnnualSavings: 200,
    maxAnnualSavings: 350,
    imgSrc: `${process.env.PUBLIC_URL}/images/smallHouse.svg`
  },
  {
    value: "mediumHouse",
    label: "3 bedrooms",
    numBedrooms: "3",
    numPanels: "10",
    minAnnualSavings: 350,
    maxAnnualSavings: 500,
    imgSrc: `${process.env.PUBLIC_URL}/images/mediumHouse.svg`
  },
  {
    value: "largeHouse",
    label: "4+ bedrooms",
    numBedrooms: "4+",
    numPanels: "16",
    minAnnualSavings: 500,
    maxAnnualSavings: 750,
    imgSrc: `${process.env.PUBLIC_URL}/images/largeHouse.svg`
  },
];

export const regions = [
  "Germany",
  "France",
  "Italy",
  "Spain",
  "Netherlands",
  "Sweden",
  "Poland",
  "Austria",
  "Portugal",
  "Belgium",
  "Denmark",
  "Czech Republic",
  "Australia",
  "United Kingdom",
  "United States",
  "Canada",
];

